<section class="p-1">
  <h6>
    <strong>Detalles de consumo</strong>
  </h6>
  <div class="card">
    <table class="table table-hover table-borderless table-sm">
      <thead>
        <tr>
          <th scope="col">Producto</th>
          <th scope="col">Total</th>
          <th scope="col">Consumido</th>
          <th scope="col">Restante</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of planConsumptionList">
          <td scope="row">
            <div class="d-flex align-items-center gap-10">
              <product-icon
                [type]="item.product.send_type"
                [badge]="true"
              ></product-icon>

              <div
                *ngIf="
                  currentPlan?.id !== item.plan.id || !item.provisioning.enabled
                "
                ngbTooltip="Ya no está disponible para consumo"
              >
                <i class="down-icon text-danger fa-solid fa-caret-down"></i>
              </div>
            </div>
          </td>
          <td>
            <div
              class="badge"
              [ngClass]="
                'badge-light-' + productStyle[item.product.send_type].color
              "
            >
              <div *ngIf="limits[item.provisioning.product_id]">
                {{ limits[item.provisioning.product_id] | number }}
              </div>
              <div *ngIf="!limits[item.provisioning.product_id]">
                <span *ngIf="item.isUnlimited">
                  <i ngbTooltip="Ilimitado" class="fa-solid fa-infinity"></i>
                </span>
                <span *ngIf="!item.isUnlimited">
                  {{ item.totalMessagesAvailable | number }}
                </span>
              </div>
            </div>
          </td>

          <td>
            <span
              class="badge"
              [ngClass]="
                'badge-light-' + productStyle[item.product.send_type].color
              "
            >
              <div *ngIf="limits[item.provisioning.product_id]">
                {{ consumed[item.provisioning.product_id] | number }}
              </div>
              <div *ngIf="!limits[item.provisioning.product_id]">
                {{ item.totalMessagesConsumed | number }}
              </div>
            </span>
          </td>

          <td>
            <div
              class="badge"
              [ngClass]="
                'badge-light-' + productStyle[item.product.send_type].color
              "
            >
              <div *ngIf="limits[item.provisioning.product_id]">
                {{ remainingUnits[item.provisioning.product_id] | number }}
              </div>
              <div *ngIf="!limits[item.provisioning.product_id]">
                <span *ngIf="item.isUnlimited">
                  <i ngbTooltip="Ilimitado" class="fa-solid fa-infinity"></i>
                </span>
                <span *ngIf="!item.isUnlimited">
                  {{ item.totalMessagesRemaining | number }}
                </span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
